<script>
import { EventBus } from 'utils/event-bus';
import { mapGetters } from 'vuex';

export default {
  name: 'VerbalDiscussionOffline',
  computed: {
    ...mapGetters([
      'hasTeacherPermissionsInCourse',
      'getCurrentDiscussion'
    ]),

    hasStudents() {
      const discussion = this.getCurrentDiscussion;
      return discussion && discussion.participations && discussion.participations.length > 0;
    },

    discussionSteps() {
      return [
        { label: 'Create Prompt',   action: () => this.handleChangeTab('prompt'),   done: true},
        { label: 'Choose Settings', action: () => this.handleChangeTab('settings'), done: true},
        { label: 'Invite Students', action: () => this.handleOpenInvite(),          done: this.hasStudents},
        { label: 'Start Discussion',action: () => this.handleStartDiscussion(),     done: false}
      ];
    },
  },

  methods: {
    handleChangeTab(tab) {
      EventBus.$emit('handleTab', tab);
    },
    handleOpenInvite() {
      EventBus.$emit('openInviteStudentsModal');
    },
    handleStartDiscussion() {
      EventBus.$emit('startDiscussion');
    },
    handleOpenWelcomeModal() {
      EventBus.$emit('showRountableWelcomeModal');
    }
  }
};
</script>
<template>
  <div v-if="hasTeacherPermissionsInCourse" class="flex items-center justify-center font-manrope">
    <div class="relative w-full max-w-2xl">
      <div class="flex flex-col items-center justify-center relative">
        <div class="h-12 w-12 rounded-full bg-white border border-gray-200 flex items-center justify-center">
          🌟
        </div>
        <div class="flex flex-col items-center justify-center px-2 pt-6 pb-6 text-center">
          <h2 class="font-poppins text-xl font-semibold text-slate-900">
            It's almost showtime
          </h2>
          <p class="mt-2 text-sm leading-6 text-slate-600">
            Get everything ready in a few steps and kick off the discussion.
          </p>
          <ol class="flex items-center text-left mt-5 space-x-4">
            <li v-for="(step, idx) in discussionSteps" :key="step.label" class="flex items-center">
              <i class="text-lg" :class="step.done ? 'fa-solid fa-circle-check text-green-600' : 'far fa-circle text-slate-400'" ></i>
              <div class="ml-3">
                <div class="text-sm font-semibold text-slate-800">
                  {{ idx + 1 }}.
                  <button @click="step.action()" class="hover:underline">
                    {{ step.label }}
                  </button>
                </div>
              </div>
            </li>
          </ol>
          <div @click="handleOpenWelcomeModal" class="mt-6 text-sm text-gray-800 font-manrope cursor-pointer hover:underline">
            How does this work?
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="w-full text-center rounded-2xl px-6 py-8">
      <div class="relative mx-auto h-12 w-12 rounded-full bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 flex items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-slate-700 dark:text-slate-200" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <circle cx="12" cy="12" r="9" stroke-width="1.6"></circle>
          <path stroke-width="1.6" d="M12 7v5l3 2"></path>
        </svg>
      </div>
      <h3 class="mt-4 font-poppins text-lg font-semibold text-slate-900 dark:text-slate-50">
        The discussion hasn't started yet
      </h3>
      <p class="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-400">
        Please hang tight — the session will begin once the teacher starts it.
      </p>
      <p class="mt-3 text-slate-500 dark:text-slate-400">
        If nothing changes for a while, try refreshing the page.
      </p>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// VerbalDiscussionOffline.vue?0a562c3e